import { FormattedMessage } from "react-intl";
import Link from "next/link";
import { useRouter } from "next/router";
const Navigation = () => {
  const { pathname } = useRouter();
  const closeNav = () => {
    document.querySelector(".nav-sidebar").classList.remove("active");
    document.querySelector("html").classList.remove("off");
  };
  return (
    <>
      <div className="main-menu">
        <ul onClick={closeNav}>
          <li className={pathname == "/" ? "active" : ""}>
            <Link href="/">
              <a>
                <FormattedMessage id="home" />
              </a>
            </Link>
          </li>
          <li className={pathname == "/about" ? "active" : ""}>
            <Link href="/about">
              <a>
                <FormattedMessage id="about" />
              </a>
            </Link>
          </li>
          <li className={pathname == "/services" ? "active" : ""}>
            <Link href="/services">
              <a>
                <FormattedMessage id="services" />
              </a>
            </Link>
          </li>
          <li className={pathname == "/teamMembers" ? "active" : ""}>
            <Link href="/teamMembers">
              <a>
                <FormattedMessage id="teamMembers" />
              </a>
            </Link>
          </li>

          <li className={pathname == "/blog" ? "active" : ""}>
            <Link href="/blog">
              <a>
                <FormattedMessage id="blog" />
              </a>
            </Link>
          </li>
          <li className={pathname == "/contact" ? "active" : ""}>
            <Link href="/contact">
              <a>
                <FormattedMessage id="contact" />
              </a>
            </Link>
          </li>
          <li className={pathname == "/faqs" ? "active" : ""}>
            <Link href="/faqs">
              <a>
                <FormattedMessage id="faqs" />
              </a>
            </Link>
          </li>
          <li className={pathname == "/hiring" ? "active" : ""}>
            <Link href="/hiring">
              <a>
                <FormattedMessage id="askEmployee" />
              </a>
            </Link>
          </li>
        </ul>
        <Link href="/hiring">
          <a className="btn">
            <FormattedMessage id="downloadProfile" />
          </a>
        </Link>
      </div>
    </>
  );
};

export default Navigation;
